// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Link-module__cardLink___debSo{padding-left:16px}.Link-module__linkText___1bzp7{padding-right:4px;white-space:nowrap}
`, "",{"version":3,"sources":["webpack://./node_modules/mintel-react-ui/dist/package/Link.css"],"names":[],"mappings":"AAAA,+BAA+B,iBAAiB,CAAC,+BAA+B,iBAAiB,CAAC,kBAAkB","sourcesContent":[".Link-module__cardLink___debSo{padding-left:16px}.Link-module__linkText___1bzp7{padding-right:4px;white-space:nowrap}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
